import IconCatch, { IconCatchProps } from '@/components/icons/icon-catch/icon-catch';
import { Box, Button, Flex, IconArrowRight } from '@cmpsr/components';
import { ReactNode } from 'react';
import IntroWizardsNavBar from '../intro-wizards-nav-bar/intro-wizard-nav-bar';

type IntroWizardsCoverProps = {
  titleNode: ReactNode;
  descriptionNode: ReactNode;
  onNextButtonClick: () => void;
  onBackButtonClick: () => void;
  icon: IconCatchProps['icon'];
};

export default function IntroWizardsCover(props: IntroWizardsCoverProps) {
  return (
    <Box minH="100svh" background="gradient.dark">
      <Box
        minH="100svh"
        background={{ base: 'none', lg: 'url(/images/footer-intro-wizards_3840px.svg)' }}
        backgroundRepeat={{ base: 'none', lg: 'no-repeat' }}
        backgroundPosition={{
          base: 'center calc(100% - 86px)',
          lg: 'center calc(100% - 56px)',
          xxl: 'center calc(100% - 86px)',
        }}
        backgroundSize={{ base: 'auto', lg: 'auto 200px' }}
      >
        <IntroWizardsNavBar onBackButtonClick={props.onBackButtonClick} showLogo hideBackButton />
        <Box px={{ base: 5, md: 10 }} py={{ base: 10, lg: 20 }}>
          <Flex
            flexDirection="column"
            alignItems={{ base: 'flex-start', lg: 'center' }}
            justifyContent="flex-start"
            gap="12"
            maxW="500px"
            mx="auto"
            color="text-light"
          >
            <IconCatch
              icon={props.icon}
              alt=""
              size="l"
              height="100px"
              w="100px"
              p={2}
              borderRadius="radii-6"
              bg="gradient.dark"
            />
            <Box>
              <Box mb={3}>{props.titleNode}</Box>
              {props.descriptionNode}
            </Box>
            <Button
              variant="accent"
              size="l"
              trailingIcon={<IconArrowRight />}
              onClick={props.onNextButtonClick}
              fontSize="16px"
            >
              Next
            </Button>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
}
